import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_SETTINGS = {
  co_innovation_enabled: true,
  co_innovation_just_enabled_banner: false,
};

const SettingsContext = createContext({
  settings: DEFAULT_SETTINGS,
  refresh: async () => {},
  loading: true,
});

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      if (data && typeof data === "object") setSettings({ ...DEFAULT_SETTINGS, ...data });
    } catch {
      // keep defaults — safer to fail-open with features visible than break the site
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SettingsContext);
}
